export default __webpack_public_path__ + "static/media/kebab-glyph-16px.d6cfdad3.svg";